import React from 'react'

import { Autocomplete } from 'mui-rff'

import { formatName } from '@edge/spark/utils'

import { UserAttributes, useUserAuthenticationIdQuery } from '@edge/spark/io-dashboards'

interface Props {
    loading?: boolean
    users: UserAttributes[]
}

export const UserSelectAutocomplete: React.FC<Props> = ({ loading, users: maybeUsers }: Props) => {
    const { data } = useUserAuthenticationIdQuery()

    const unsortedUsers = maybeUsers || []
    const users = unsortedUsers.sort((a, b) =>
        formatName(a).localeCompare(formatName(b), undefined, {
            sensitivity: 'base',
        }),
    )
    const ownId = data?.user?.attributes?.authenticationId
    const ownIndex = users?.findIndex((user) => user.authenticationId === ownId)
    const groupByReady = ownIndex !== -1
    const sortedUsers =
        ownIndex && groupByReady ? [users[ownIndex], ...users.slice(0, ownIndex), ...users.slice(ownIndex + 1)] : users

    return users?.length ? (
        <Autocomplete
            required
            label="User"
            name="userId"
            loading={loading}
            options={sortedUsers}
            groupBy={
                groupByReady
                    ? ({ authenticationId }: UserAttributes): string =>
                          authenticationId === ownId ? 'My Dashboards' : 'Other Users'
                    : undefined
            }
            // String type regression
            // https://github.com/mui/material-ui/issues/23708
            getOptionLabel={(opt) => (typeof opt === 'string' ? opt : formatName(opt))}
            getOptionValue={({ authenticationId }: UserAttributes): string | null | undefined => authenticationId}
            textFieldProps={{ fullWidth: true, margin: 'normal' }}
        />
    ) : null
}
